import * as React from 'react';
import {
  CartSidebarLeftIcon,
  CartSidebarRightIcon,
  CartModalIcon,
  CartDropdownIcon,
} from '@packages/systems/spring';
import {CART_STATES} from '@packages/systems/commerce/constants';
import {enumWithTooltip} from './EnumWithTooltip';

export const CART_TYPES = [
  {value: 'modal', label: <CartModalIcon />, tooltip: 'Modal', disabled: false},
  {
    value: 'leftSidebar',
    label: <CartSidebarLeftIcon />,
    tooltip: 'Sidebar-left',
    disabled: false,
  },
  {
    value: 'rightSidebar',
    label: <CartSidebarRightIcon />,
    tooltip: 'Sidebar-right',
    disabled: false,
  },
  {
    value: 'dropdown',
    label: <CartDropdownIcon />,
    tooltip: 'Dropdown',
    disabled: false,
  },
] as const;

const CART_STATES_TITLE = (isEmpty: boolean) => [
  {value: CART_STATES.DEFAULT, label: 'Default', disabled: isEmpty},
  {value: CART_STATES.EMPTY, label: 'Empty'},
  {value: CART_STATES.ERROR, label: 'Error', disabled: isEmpty},
];

// @ts-expect-error - TS2345 - Argument of type 'readonly [{ readonly value: "modal"; readonly label: Element; readonly tooltip: "Modal"; readonly disabled: false; }, { readonly value: "leftSidebar"; readonly label: Element; readonly tooltip: "Sidebar-left"; readonly disabled: false; }, { ...; }, { ...; }]' is not assignable to parameter of type 'Value[]'.
export const CartTypeEnum = enumWithTooltip(CART_TYPES);
export const CartStatesEmptyEnum = enumWithTooltip(CART_STATES_TITLE(true));
export const CartStatesEnum = enumWithTooltip(CART_STATES_TITLE(false));
